'use client';
import { PlayersOnBench } from '@/modules/league/new-components/types';

interface MatchCardProps {
  benchGroup: { ratingSessionPlayersOnBench: PlayersOnBench[] };
}

export const BenchCard = ({ benchGroup }: MatchCardProps) => {
  const { ratingSessionPlayersOnBench } = benchGroup;

  return (
    <div
      id='bench'
      className='flex h-auto w-full flex-col gap-2.5 rounded-lg bg-white p-4 shadow-sm hover:bg-gray-50 md:max-w-[350px] lg:max-w-[410px]'
    >
      {/* Bench Header */}
      <div className='flex flex-col justify-between gap-3'>
        <div className='mb-4 flex flex-row items-start justify-between'>
          <h3 className='flex text-base font-semibold lg:text-lg'>On the Bench</h3>
        </div>
        {ratingSessionPlayersOnBench.map((player, i) => {
          return (
            <div className='flex flex-row items-center justify-between' key={i}>
              <span className='text-base font-medium'>{`${i + 1}. ${player.FirstName} ${player.LastName}`}</span>
              {player.IsRemoved ? (
                <span className='text-sm font-semibold text-gray-800'>Removed</span>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};
